import { useContext, useState, useEffect, useMemo } from 'react';
import LocaleContext from '../LocaleContext.js';
import { DEFAULT_LANG } from '../../../constants/defaultLang.js';

const useLocaleToDeriveDefault = (override, defaultValue) => {
  const {
    shouldDefault
  } = useContext(LocaleContext);
  const [isServer, setIsServer] = useState(true);
  useEffect(() => {
    // no need to force a rerender if we know we can override or have already identified the lang
    if (!override || typeof shouldDefault === 'undefined') {
      setIsServer(false);
    }
  }, [override, shouldDefault]);
  return useMemo(() => {
    if (override) {
      return override;
    }
    if (shouldDefault) {
      return defaultValue;
    }

    // can't evaluate the document in a server environment
    if (!isServer) {
      // this will be undefined when used outside of context
      if (shouldDefault === undefined) {
        const htmlLocale = globalThis.document && globalThis.document.documentElement.getAttribute('lang');
        const derivedLang = htmlLocale ? htmlLocale.split('-')[0] : '';
        if (derivedLang === DEFAULT_LANG) {
          return defaultValue;
        }
      }
    }
    if (typeof defaultValue === 'function') {
      return () => {};
    }
    return '';
  }, [override, shouldDefault, defaultValue, isServer]);
};
var useLocaleToDeriveDefault$1 = useLocaleToDeriveDefault;

export { useLocaleToDeriveDefault$1 as default };
